/**
 * Michelangelo Phase 2: Assessment Instrument Service
 * Fetches assessment instruments (IPCAF, etc.) from Firestore.
 */

import { db } from '../firebase';
import { doc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';

const COLLECTION = 'assessment_instruments';

class AssessmentInstrumentService {
  constructor() {
    this.collectionRef = collection(db, COLLECTION);
  }

  async getInstrument(instrumentId) {
    const ref = doc(db, COLLECTION, instrumentId);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    return { id: snap.id, ...snap.data() };
  }

  async listInstruments(filters = {}) {
    let q = this.collectionRef;
    const constraints = [];
    if (filters.domain) constraints.push(where('domain', '==', filters.domain));
    if (filters.status) constraints.push(where('status', '==', filters.status));
    if (constraints.length > 0) q = query(this.collectionRef, ...constraints);
    const snapshot = await getDocs(q);
    return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  }
}

export default new AssessmentInstrumentService();
